export interface LoginRequest {
  readonly identifier: string;
  readonly password: string;
  readonly rememberMe: boolean;
}

export interface LoginResponse {
  readonly accessToken?: string;
  readonly refreshToken?: string;
  readonly expiresAt?: string;
  readonly user: AuthenticatedStudent;
}

export interface AuthenticatedStudent {
  readonly id: string;
  readonly studentCode: string;
  readonly fullName: string;
  readonly email: string;
  readonly avatarUrl?: string;
  readonly roles: readonly StudentRole[];
  readonly status: StudentAccountStatus;
}

export type StudentRole = 'student';

export type StudentAccountStatus = 'active' | 'locked' | 'pending';

export type AuthErrorCode =
  | 'INVALID_CREDENTIALS'
  | 'ACCOUNT_LOCKED'
  | 'ACCOUNT_PENDING'
  | 'NETWORK_ERROR'
  | 'SERVER_ERROR'
  | 'UNKNOWN_ERROR';

export interface AuthUiError {
  readonly code: AuthErrorCode;
  readonly message: string;
}

export interface AuthState {
  readonly user: AuthenticatedStudent | null;
  readonly isAuthenticated: boolean;
  readonly isLoading: boolean;
  readonly error: AuthUiError | null;
  readonly accessToken?: string;
  readonly expiresAt?: string;
}

export const initialAuthState: AuthState = {
  user: null,
  isAuthenticated: false,
  isLoading: false,
  error: null,
  accessToken: undefined,
  expiresAt: undefined,
};

export interface AuthErrorResponse {
  readonly code?: string;
  readonly message?: string;
}
